import React from 'react';
import '../template-file-css/document-file-template.css';


export const NcGeneral_CCA = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NcGeneral_CCA' className='file-pdf-document'>
            <div className='file-template'>


                <p>
                    <span className='eleHeader'>B.PRESENTING PROBLEM(S)/NEED(S) (including precipitating events and sources of
                        distress) :</span>
                    <textarea id="txt_1" name="txt_1" className='add-only'></textarea>
                </p>

                <h2>C. History of Present Illness</h2>
                <h3>Conduct/Legal Problems</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_1" name="cb_1" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_2" name="cb_2" className='add-only' value="1" /> Lying
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_3" name="cb_3" className='add-only' value="1" /> Stealing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_4" name="cb_4" className='add-only' value="1" /> Running Away From Home
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_5" name="cb_5" className='add-only' value="1" /> Assault
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_6" name="cb_6" className='add-only' value="1" /> Fighting
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_7" name="cb_7" className='add-only' value="1" /> Property Destruction
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_8" name="cb_8" className='add-only' value="1" /> Fire Setting
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_9" name="cb_9" className='add-only' value="1" /> Arrests
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_10" name="cb_10" className='add-only' value="1" /> Convictions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_11" name="cb_11" className='add-only' value="1" /> Imprisoned
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_12" name="cb_12" className='add-only' value="1" /> Impulse Control
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_13" name="cb_13" className='add-only' value="1" /> Family Desertion
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_14" name="cb_14" className='add-only' value="1" /> Exhibitionism
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_15" name="cb_15" className='add-only' value="1" /> Oppositional Defiant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_16" name="cb_16" className='add-only' value="1" /> Sexual Acting Out
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_17" name="cb_17" className='add-only' value="1" /> Gang Involvement
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Specify setting where behavior occurs:</span>
                    <textarea id="txt_18" name="txt_18" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Clarify or Other:</span>
                    <textarea id="txt_19" name="txt_19" className='add-only'></textarea>
                </p>
                <h3>Substance Abuse</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_20_1" name="rb_20" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_20_2" name="rb_20" className='add-only' value="2" /> Has Abused
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_20_3" name="rb_20" className='add-only' value="3" /> Is Currently Abusing:
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If is Currently Abusing, Select which drug(s)"</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_21" name="cb_21" className='add-only' value="1" /> Alcohol
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_22" name="cb_22" className='add-only' value="1" /> Narcotics
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_23" name="cb_23" className='add-only' value="1" /> Stimulants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_24" name="cb_24" className='add-only' value="1" /> Hallucinogens
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_25" name="cb_25" className='add-only' value="1" /> Inhalants
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_26" name="cb_26" className='add-only' value="1" /> Prescription Drugs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_27" name="cb_27" className='add-only' value="1" /> Depressants
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_28" name="cb_28" className='add-only' value="1" /> Cannabis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_29" name="cb_29" className='add-only' value="1" /> IV Drugs
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>How often currently abusing</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_30" name="cb_30" className='add-only' value="1" /> Daily
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_31" name="cb_31" className='add-only' value="1" /> Weekly
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_32" name="cb_32" className='add-only' value="1" /> Monthly Use
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>History of:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_33" name="cb_33" className='add-only' value="1" /> DTs
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_34" name="cb_34" className='add-only' value="1" /> Blackouts
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_35" name="cb_35" className='add-only' value="1" /> Loss of Control of Use
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_36" name="cb_36" className='add-only' value="1" /> Personality Change
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_37" name="cb_37" className='add-only' value="1" /> Hallucination
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_38" name="cb_38" className='add-only' value="1" /> Increase or Decrease of Tolerance
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Withdrawal Signs</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_39" name="cb_39" className='add-only' value="1" /> Dry Mouth
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_40" name="cb_40" className='add-only' value="1" /> Headache
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_41" name="cb_41" className='add-only' value="1" /> Stomachache
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_42" name="cb_42" className='add-only' value="1" /> Vomiting
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_43" name="cb_43" className='add-only' value="1" /> Shakes
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_44" name="cb_44" className='add-only' value="1" /> Nervous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_45" name="cb_45" className='add-only' value="1" /> Jittery
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_46" name="cb_46" className='add-only' value="1" /> Mid-Sleep Awakening
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_47" name="cb_47" className='add-only' value="1" /> Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_48" name="cb_48" className='add-only' value="1" /> Genetic Predisposition
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_49" name="cb_49" className='add-only' value="1" /> “Morning After” Drinking/Drugging
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_50" name="cb_50" className='add-only' value="1" /> Denial
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Other addictive behavior (e.g. Gambling):</span>
                    <textarea id="txt_51" name="txt_51" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Other:</span>
                    <textarea id="txt_52" name="txt_52" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Complaints From Others About Use:</span>
                    <textarea id="txt_53" name="txt_53" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Job Loss or Job Problems Due to Use:</span>
                    <textarea id="txt_54" name="txt_54" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Medical Problems Due to Use:</span>
                    <textarea id="txt_55" name="txt_55" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Significant Period of Sobriety:</span>
                    <textarea id="txt_56" name="txt_56" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Depressive Symptoms</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_57" name="cb_57" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_58" name="cb_58" className='add-only' value="1" /> Sadness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_59" name="cb_59" className='add-only' value="1" /> Fatigue
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_60" name="cb_60" className='add-only' value="1" /> Hypoactive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_61" name="cb_61" className='add-only' value="1" /> Anhedonia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_62" name="cb_62" className='add-only' value="1" /> Feelings of Worthlessness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_63" name="cb_63" className='add-only' value="1" /> Guilt Feelings
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_64" name="cb_64" className='add-only' value="1" /> Crying
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_65" name="cb_65" className='add-only' value="1" /> Suicidal Ideation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_63_1" name="cb_63_1" className='add-only' value="1" /> Irritability
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_64_1" name="cb_64_1" className='add-only' value="1" /> Decreased Concentration
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_65_1" name="cb_65_1" className='add-only' value="1" />  Clarify or Other:
                    <br />
                    <textarea id="txt_66" name="txt_66" className='add-only'></textarea>
                </p>
                <h3>Biological Functions</h3>
                <table>

                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb_67" name="cb_67" className='add-only' value="1" /> No Known Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sleep</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSleep_1" name="cbSleep_1" className='add-only' value="1" /> No Change</td>
                        <td className='w-187'><input type="checkbox" id="cbSleep_2" name="cbSleep_2" className='add-only' value="1" /> Increased</td>
                        <td className='w-187'><input type="checkbox" id="cbSleep_3" name="cbSleep_3" className='add-only' value="1" /> Decreased</td>
                        <td className='w-187'><input type="checkbox" id="cbSleep_4" name="cbSleep_4" className='add-only' value="1" /> Restless</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appetite:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbAppetite_1" name="cbAppetite_1" className='add-only' value="1" /> No Change</td>
                        <td className='w-187'><input type="checkbox" id="cbAppetite_2" name="cbAppetite_2" className='add-only' value="1" /> Increased</td>
                        <td className='w-187'><input type="checkbox" id="cbAppetite_3" name="cbAppetite_3" className='add-only' value="1" /> Decreased</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sexual Behavior:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbSexualBehavior_1" name="cbSexualBehavior_1" className='add-only' value="1" /> No Change</td>
                        <td className='w-187'><input type="checkbox" id="cbSexualBehavior_2" name="cbSexualBehavior_2" className='add-only' value="1" /> Increased</td>
                        <td className='w-187'><input type="checkbox" id="cbSexualBehavior_3" name="cbSexualBehavior_3" className='add-only' value="1" /> Decreased</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Elimination:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbElimination_1" name="cbElimination_1" className='add-only' value="1" /> No Change</td>
                        <td className='w-187'><input type="checkbox" id="cbElimination_2" name="cbElimination_2" className='add-only' value="1" /> Increased</td>
                        <td className='w-187'><input type="checkbox" id="cbElimination_3" name="cbElimination_3" className='add-only' value="1" /> Decreased</td>
                        <td className='w-187'><input type="checkbox" id="cbElimination_4" name="cbElimination_4" className='add-only' value="1" /> Incontinence</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type="checkbox" id="cbEnuresis" name="cbnuresis" className='add-only' value="1" /> Enuresis</td> 
                        <td className='w-187'><input type="checkbox" id="cbPoorHygiene" name="cbPoorHygiene" className='add-only' value="1" /> Poor Hygiene</td> 
                        <td className='w-187'><input type="checkbox" id="cbEncopresis" name="cbEncopresis" className='add-only' value="1" /> Encopresis</td> 
                        <td className='w-187'><input type="checkbox" id="cbAmenorrhea" name="cbAmenorrhea" className='add-only' value="1" /> Amenorrhea</td> 
                    </tr> 
                </table> 
                <p>
                    <input type="checkbox" id="cb_86" name="cb_86" className='add-only' value="1" /> Clarify ir Other:
                    <textarea id="txt_87" name="txt_87" className='add-only'></textarea>
                </p>

                <p><span className='eleHeader'>Manic Symptoms:</span></p>
 
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_88" name="cb_88" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_90" name="cb_90" className='add-only' value="1" /> Euphoria
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_91" name="cb_91" className='add-only' value="1" /> Hyperactivity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_92" name="cb_92" className='add-only' value="1" /> Pressured Speech
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_93" name="cb_93" className='add-only' value="1" /> Grandiosity
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_94" name="cb_94" className='add-only' value="1" /> Extravagance w/Money
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_95" name="cb_95" className='add-only' value="1" /> Hypersexual
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_96" name="cb_96" className='add-only' value="1" /> Distractibility
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_97" name="cb_97" className='add-only' value="1" /> Clarify or Other
                    <textarea id="txt_98" name="txt_98" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>Attention Symptoms:</span></p> 
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_99" name="cb_99" className='add-only' value="1" /> Fails to finish things
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_100" name="cb_100" className='add-only' value="1" /> Cannot concentrate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_101" name="cb_101" className='add-only' value="1" /> Cannot sit still,
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_102" name="cb_102" className='add-only' value="1" /> restless or hyperactive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_103" name="cb_103" className='add-only' value="1" /> Fidgets
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_104" name="cb_104" className='add-only' value="1" /> Daydreams
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_105" name="cb_105" className='add-only' value="1" /> Acts impulsively
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_106" name="cb_106" className='add-only' value="1" /> Difficulty following directions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_107" name="cb_107" className='add-only' value="1" /> Talks excessively/out of turn
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_108" name="cb_108" className='add-only' value="1" /> Messy/Disorganized
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_109" name="cb_109" className='add-only' value="1" /> Inattentive/easily distracted
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_110" name="cb_110" className='add-only' value="1" /> Fails to carry out assigned tasks
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_111" name="cb_111" className='add-only' value="1" /> Other:<br />
                    <textarea id="txt_112" name="cb_112" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>Anxiety Symptoms:</span></p> 
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_113" name="cb_113" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_114" name="cb_100" className='add-only' value="1" /> Anxiety
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_115" name="cb_115" className='add-only' value="1" /> Conversion
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_116" name="cb_116" className='add-only' value="1" /> Obsessions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_117" name="cb_117" className='add-only' value="1" /> Compulsions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_118" name="cb_118" className='add-only' value="1" /> Phobia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_119" name="cb_119" className='add-only' value="1" /> Multiple Somatic Complaints
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_120" name="cb_120" className='add-only' value="1" /> Bed Wetting
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_121" name="cb_121" className='add-only' value="1" /> Nightmares
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_122" name="122" className='add-only' value="1" />  Panic
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_123" name="cb_123" className='add-only' value="1" /> Clarify or Other<br />
                    <textarea id="txt_124" name="cb_124" className='add-only'></textarea>
                </p> 
                <h3>Presence of Lethality:</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Suicidal</span>
                            <input type="radio" id="rb_163_Y" name="rb_163" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rb_163_N" name="rb_163" className='add-only' value="1" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Homicidal</span>
                            <input type="radio" id="rb_164_Y" name="rb_164" className='add-only' value="1" />  Yes &nbsp;
                            <input type="radio" id="rb_164_N" name="rb_164" className='add-only' value="1" />  No
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Describe (What, When):</span>
                    <textarea id="txt_165" name="txt_165" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>Psychotic Symptoms:</span></p> 
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_166" name="cb_166" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_167" name="cb_167" className='add-only' value="1" /> Ideas of Reference
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_168" name="cb_168" className='add-only' value="1" /> Paranoid Trends
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_169" name="cb_169" className='add-only' value="1" /> Delusions
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Hallucinations</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_170_1" name="rb_170" className='add-only' value="1" />  Auditory
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_170_2" name="rb_170" className='add-only' value="2" />  Visual
                        </td>
                    </tr>
                </table>
                <p><span className='eleHeader'>History of Trauma:</span></p>  
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_171" name="cb_171" className='add-only' value="1" /> Assault
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_172" name="cb_172" className='add-only' value="1" /> Rape
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_173" name="cb_173" className='add-only' value="1" /> Shooting
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_174" name="cb_174" className='add-only' value="1" /> Pysical Abuse As a Child
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_175" name="cb_175" className='add-only' value="1" /> Spouse Abuse
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_176" name="cb_176" className='add-only' value="1" /> Auto Accident
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_177" name="cb_177" className='add-only' value="1" /> Robbery
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_178" name="cb_178" className='add-only' value="1" /> Sexual Abuse As a Child
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_179" name="cb_179" className='add-only' value="1" />  Clarify or Other
                    <textarea id="txt_180" name="txt_180" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>Developmental Condition:</span></p>  
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_181_1" name="rb_181" className='add-only' value="1" /> Normal
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_181_2" name="rb_181" className='add-only' value="2" />  Mental Retardation
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Specify:</span>
                    <textarea id="txt_182" name="txt_182" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Physical Impairment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_183" name="cb_183" className='add-only' value="1" /> Hearing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_184" name="cb_184" className='add-only' value="1" /> Vision
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_185" name="cb_185" className='add-only' value="1" /> Motor
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_186" name="cb_186" className='add-only' value="1" /> Other<br />
                    <textarea id="txt_187" name="txt_187" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_188" name="cb_188" className='add-only' value="1" /> Autism
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_189" name="cb_189" className='add-only' value="1" />  Head Injury
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_190" name="cb_190" className='add-only' value="1" /> Other <br />
                    <textarea id="txt_191" name="txt_191" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>Pyschological Strengths:</span></p> 
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_192" name="cb_192" className='add-only' value="1" /> Resilience
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_193" name="cb_193" className='add-only' value="1" /> Optimism
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_194" name="cb_194" className='add-only' value="1" /> Spirituality
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_195" name="cb_195" className='add-only' value="1" /> Sense of Humor
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_196" name="cb_196" className='add-only' value="1" /> Creative
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_197" name="cb_197" className='add-only' value="1" /> Flexible
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_198" name="cb_198" className='add-only' value="1" /> Motivated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_199" name="cb_199" className='add-only' value="1" /> Patience
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_200" name="cb_200" className='add-only' value="1" /> Ethical
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_201" name="cb_201" className='add-only' value="1" /> Educational Achievement
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_202" name="cb_202" className='add-only' value="1" /> Other<br />
                    <textarea id="txt_203" name="txt_203" className='add-only'></textarea>
                </p>
                <p><span className='eleHeader'>Relationship Problems:</span></p> 
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_204" name="cb_204" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_205" name="cb_205" className='add-only' value="1" /> No Friends
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_206" name="cb_206" className='add-only' value="1" /> Running Away From Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_207" name="cb_207" className='add-only' value="1" /> Separation or Divorce
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_208" name="cb_208" className='add-only' value="1" /> Visitation or Custody Dispute
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_209" name="cb_209" className='add-only' value="1" /> Child Neglect
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_210" name="cb_210" className='add-only' value="1" /> Child Abuse
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_211" name="cb_211" className='add-only' value="1" /> Death in Family
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_212" name="cb_212" className='add-only' value="1" /> No Significant Relationships
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Conflicts</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cb_213" name="cb_213" className='add-only' value="1" /> Peers
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cb_214" name="cb_214" className='add-only' value="1" /> Siblings
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cb_215" name="cb_215" className='add-only' value="1" /> Parents
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cb_216" name="cb_216" className='add-only' value="1" /> Spouse
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="cb_217" name="cb_217" className='add-only' value="1" /> Children
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_218" name="cb_218" className='add-only' /> Clarify or Other<br />
                    <textarea id="txt_219" name="txt_219" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_220" name="cb_220" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_220_1" name="cb_220_1" className='add-only' value="1" /> Financial Stress
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_221" name="cb_221" className='add-only' value="1" /> Debt-Ridden
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_222" name="cb_222" className='add-only' value="1" /> Reckless Spending
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_223" name="cb_223" className='add-only' value="1" /> Bankrupt
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_224" name="cb_224" className='add-only' value="1" /> Desitute
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Needs Financial Aid</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_225" name="cb_225" className='add-only' value="1" /> SSI
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_226" name="cb_226" className='add-only' value="1" /> Social Security
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_227" name="cb_227" className='add-only' value="1" /> AFDC
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_228" name="cb_228" className='add-only' value="1" /> Medicaid
                        </td>
                    </tr>
                </table>
                <p><span className='eleHeader'>Housing Problems:</span></p> 
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_229" name="cb_229" className='add-only' value="1" /> None Known
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_230" name="cb_230" className='add-only' value="1" /> Dilapidated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_231" name="cb_231" className='add-only' value="1" /> Dilapidated
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_232" name="cb_232" className='add-only' value="1" /> Must Move
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_233" name="cb_233" className='add-only' value="1" /> Inappropriate Cohabitants
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_234" name="cb_234" className='add-only' value="1" /> Homeless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb_235" name="cb_235" className='add-only' value="1" /> Needs Institutional Placement or
                            Transfer
                        </td> 
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_236" name="cb_236" className='add-only' value="1" /> Clarify or Other:
                    <textarea id="txt_237" name="txt_237" className='add-only'></textarea>
                </p>
                <h3>MH or SA Treatment (if any)</h3>
                <p>
                    <span className='eleHeader'>Outpatient</span>
                    <textarea id="txt_238" name="txt_238" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Inpatient</span>
                    <textarea id="txt_239" name="txt_239" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_240" name="cb_240" className='add-only' value="1" /> Asthma
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_241" name="cb_241" className='add-only' value="1" /> High Blood Pressure
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_242" name="cb_242" className='add-only' value="1" /> Heart Conditions
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_243" name="cb_243" className='add-only' value="1" /> Pregnant
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_244" name="cb_244" className='add-only' value="1" /> Seizures
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_245" name="cb_245" className='add-only' value="1" /> Major Illness
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_246" name="cb_246" className='add-only' value="1" /> Hospitalization
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_247" name="cb_247" className='add-only' value="1" /> Surgery
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_248" name="cb_248" className='add-only' value="1" /> Loss of Consciousness
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_249" name="cb_249" className='add-only' value="1" /> Dental Needs
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_250" name="cb_250" className='add-only' value="1" /> Diabetes
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_251" name="cb_251" className='add-only' value="1" /> Emphysema
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_252" name="cb_252" className='add-only' value="1" /> Hepatitis
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_253" name="cb_253" className='add-only' value="1" /> HIV/AIDS
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_254" name="cb_254" className='add-only' value="1" /> Other StD's
                    <textarea id="cb_255" name="cb_255" className='add-only'></textarea>
                </p>
                <h3>Health Information/History</h3>
                <p>
                    <span className='eleHeader'>Current Medications and response (if known):</span>
                    <textarea id="txt_257" name="txt_257" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Past Medications and response (if known):</span>
                    <textarea id="txt_257_1" name="txt_257_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Known Allergies:</span>
                    <textarea id="txt_258" name="txt_258" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Under Physician's Care?</span>
                            <input type="radio" id="rb_259_Y" name="rb_259" className='add-only' value="1" />  Yes &nbsp;
                            <input type="radio" id="rb_259_N" name="rb_259" className='add-only' value="1" />  No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of Physician?</span>
                            <input type='text' id="txt_260" name="txt_260" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2>D. Family and Social History</h2>
                <p>

                    <span className='eleHeader'>Family History of Substance Abuse</span>
                    <input type="radio" id="rb_261_1" name="rb_261" className='add-only' value="1" /> Unknown&nbsp;
                    <input type="radio" id="rb_261_2" name="rb_261" className='add-only' value="2" /> No&nbsp;
                    <input type="radio" id="rb_261_3" name="rb_261" className='add-only' value="3" /> Yes
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txt_262" name="txt_262" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Family History of Mental Illness</span>
                    <input type="radio" id="rb_263_1" name="rb_263" className='add-only' value="1" /> Unknown&nbsp;
                    <input type="radio" id="rb_263_2" name="rb_263" className='add-only' value="2" /> No&nbsp;
                    <input type="radio" id="rb_263_3" name="rb_263" className='add-only' value="3" /> Yes
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txt_264" name="txt_264" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Family History of Legal Problems</span>
                    <input type="radio" id="rb_265_1" name="rb_265" className='add-only' value="1" /> Unknown&nbsp;
                    <input type="radio" id="rb_265_2" name="rb_265" className='add-only' value="2" /> No&nbsp;
                    <input type="radio" id="rb_265_3" name="rb_265" className='add-only' value="3" /> Yes
                    <span className='eleHeader'>Describe:</span>
                    <textarea id="txt_266" name="txt_266" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Employment History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_267_1" name="rb_267" className='add-only' value="1" /> Stable Employment
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_267_2" name="rb_267" className='add-only' value="1" /> Jobs Held Briefly 
                            <span className='small'>(Less than 2 Years)</span>
                            
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_268_1" name="rb_268" className='add-only' value="1" /> Frequently Fired
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_268_2" name="rb_268" className='add-only' value="1" /> Unemployed
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_269_1" name="rb_269" className='add-only' value="1" /> Retired
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_269_2" name="rb_269" className='add-only' value="1" /> On Disability
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_270_1" name="rb_270" className='add-only' value="1" /> Student
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_271" name="cb_271" className='add-only' value="1" />  Other:
                    <textarea id="txt_272" name="cb_272" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Military</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_273_1" name="rb_273" className='add-only' value="1" /> Navy
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_273_2" name="rb_273" className='add-only' value="1" /> USMC
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_274_1" name="rb_274" className='add-only' value="1" /> Air Force
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_274_2" name="rb_274" className='add-only' value="1" /> Army
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_275_1" name="rb_275" className='add-only' value="1" /> Coast Guard
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_275_2" name="rb_275" className='add-only' value="1" /> National Guard
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_276_1" name="rb_276" className='add-only' value="1" /> Merchant Marines
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_276_2" name="rb_276" className='add-only' value="1" /> Reserves
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_277_1" name="rb_277" className='add-only' value="1" /> Honorable Discharge
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_277_2" name="rb_277" className='add-only' value="1" /> Other Than Honorable Discharge
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_278_1" name="rb_278" className='add-only' value="1" /> Bad Conduct Discharge
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_278_2" name="rb_278" className='add-only' value="1" /> Medical Discharge
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_280_1" name="rb_280" className='add-only' value="1" />  Combat Action
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-375'>
                            <span className='eleHeader'>Time Served:</span>
                            <input type='text' id="txt_279" name="txt_279" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Using VA Medical Benefits</span>
                            <input type="radio" id="rb_281_1" name="rb_281" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rb_281_2" name="rb_281" className='add-only' value="2" /> No
                        </td>
                    </tr> 
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Developmental Milestones</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_282_1" name="rb_282" className='add-only' value="1" /> None Known
                        </td>

                        <td className='w-375'>
                            <input type="radio" id="rb_282_2" name="rb_282" className='add-only' value="2" /> WNL
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Testing Exists or Recommended</span>
                            <input type="radio" id="rb_283_1" name="rb_283" className='add-only' value="1" /> Yes&nbsp;
                            <input type="radio" id="rb_283_2" name="rb_283" className='add-only' value="2" /> No
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Clarify or Describe:</span>
                    <textarea id="txt_284" name="txt_284" className='add-only'></textarea>
                </p>
                <p>
                    <h3>Educational History</h3>
                </p>
                <table> 
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Highest Level of Education Completed:</span>
                            <input type='text' id="txt_285" name="txt_285" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Grade:</span>
                            <input type='text' id="txt_286" name="txt_286" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current School:</span>
                            <input type='text' id="txt_287" name="txt_287" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Special Education:</span>
                            <input type='text' id="txt_288" name="txt_288" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Academic Functioning:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_289" name="cb_289" className='add-only' value="1" /> Disruptive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_290" name="cb_290" className='add-only' value="1" /> Underachieving
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_291" name="cb_291" className='add-only' value="1" /> Suspension
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_291_1" name="cb_291_1" className='add-only' value="1" /> Expulsion
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_291_2" name="cb_291_2" className='add-only' value="1" /> Bullied
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_292" name="cb_292" className='add-only' value="1" /> Gifted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_293" name="cb_293" className='add-only' value="1" /> Extracurricular Activities
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_294" name="cb_294" className='add-only' value="1" /> Good Grades
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_295" name="cb_295" className='add-only' value="1" /> Other<br />
                    <textarea id="txt_296" name="txt_296" className='add-only'></textarea>
                </p>
                <h3>Family Of Origin History</h3>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Number of siblings</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cb_297" name="cb_297" className='add-only' value="1" /> Only Child
                        </td>
                        <td className='w-300'>
                            Sisters <input type='text' id="txt_298" name="txt_298" className='add-only w-200 custom-add-only ' />
                        </td>
                        <td className='w-300'>
                            Brothers <input type='text' id="txt_299" name="txt_299" className='add-only  w-200 custom-add-only ' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client Sibling Order</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_300_1" name="cb_300" className='add-only' value="1" /> Oldest
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_300_2" name="cb_300" className='add-only' value="2" /> Middle
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_300_3" name="cb_300" className='add-only' value="3" /> Youngest
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Socio-Economic Level</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_301_1" name="cb_301" className='add-only' value="1" /> Upper
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_301_2" name="cb_301" className='add-only' value="2" /> Middle
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_301_3" name="cb_301" className='add-only' value="3" /> Lower
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Who Raised Client</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_302_1" name="cb_302" className='add-only' value="1" /> Parents
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_302_2" name="cb_302" className='add-only' value="2" /> Grandparents
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_302_3" name="cb_302" className='add-only' value="3" /> Foster Parent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb_303" name="cb_303" className='add-only' value="1" /> Other:
                            <input type='text' id="txt_304" name="txt_304" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Parent/Caretakers</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_305" name="cb_305" className='add-only' value="1" /> Seperated
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_306" name="cb_306" className='add-only' value="1" /> Divorced
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_307" name="cb_307" className='add-only' value="1" /> Married
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_308" name="cb_308" className='add-only' value="1" /> Unmarried
                        </td>
                        <td className='w-750'>
                            <input type="checkbox" id="cb_309" name="cb_309" className='add-only' value="1" /> Deceased Mother/Father
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Age Client Left Home</span>
                            <input type='text' id="txt_310" name="cb_310" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Other:</span>
                    <textarea id="txt_311" name="txt_311" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Describe relationship with parent(s)/sibling(s):</span>
                    <textarea id="txt_312" name="txt_312" className='add-only'></textarea>
                </p>
                <h3>Current Client Information</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Marital Status:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rb_313_1" name="rb_313" className='add-only' value="1" /> Single
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rb_313_2" name="rb_313" className='add-only' value="2" /> Married
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rb_313_3" name="rb_313" className='add-only' value="3" /> Domestic Partners
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rb_313_4" name="rb_313" className='add-only' value="4" /> Seperated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rb_313_5" name="rb_313" className='add-only' value="5" /> Divorced
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rb_313_6" name="rb_313" className='add-only' value="6" /> Widowed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Children:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_314_1" name="rb_314" className='add-only' value="1" /> Male
                        </td>
                        <td className='w-250'>
                            How Many? <input type='text' id="txt_315" name="txt_315" className='add-only' />
                        </td>
                        <td className='w-250'>
                            Ages? <input type='text' id="txt_316" name="txt_316" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_314_2" name="rb_314" className='add-only' value="2" /> Female
                        </td>
                        <td className='w-250'>
                            How Many? <input type='text' id="txt_317" name="txt_317" className='add-only' />
                        </td>
                        <td className='w-250'>
                            Ages? <input type='text' id="txt_318" name="txt_318" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Other:</span>
                    <textarea id="txt_319" name="txt_319" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Family Strengths</span>
                    <textarea id="txt_320" name="txt_320" className='add-only'></textarea>
                </p>
                <h2>E.Mental Status Exam</h2>
                <h3>General Appearance</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Physical Stature</span>
                            <input type="radio" id="rb_321_1" name="rb_321" className='add-only' value="1" /> Small &nbsp;
                            <input type="radio" id="rb_321_2" name="rb_321" className='add-only' value="1" /> Average &nbsp;
                            <input type="radio" id="rb_321_3" name="rb_321" className='add-only' value="1" /> Large
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Posture</span>
                            <input type="radio" id="rb_322_1" name="rb_322" className='add-only' value="1" /> Stooped &nbsp;
                            <input type="radio" id="rb_322_2" name="rb_322" className='add-only' value="2" /> Stiff
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_323_1" name="rb_323" className='add-only' value="1" /> Well- Groomed
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_323_2" name="rb_323" className='add-only' value="2" /> Dirty
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_323_3" name="rb_323" className='add-only' value="3" /> Careless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_323_4" name="rb_323" className='add-only' value="4" /> Disheveled
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_323_5" name="rb_323" className='add-only' value="5" /> Obese
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_323_6" name="rb_323" className='add-only' value="6" /> Slim
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_323_7" name="rb_323" className='add-only' value="7" /> Unshaven
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-375'>
                            <input type="checkbox" id="cb_324" name="cb_324" className='add-only' value="1" /> Other
                            <input type='text' id="txt_325" name="txt_325" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p><span className='eleHeader'>Attitude:</span></p>
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_326" name="cb_326" className='add-only' value="1" /> Appropriate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_327" name="cb_327" className='add-only' value="1" /> Dependent
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_328" name="cb_328" className='add-only' value="1" /> Passive-Aggressive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_329" name="cb_329" className='add-only' value="1" /> Manipulative
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_330" name="cb_330" className='add-only' value="1" /> Cooperative
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_331" name="cb_331" className='add-only' value="1" /> Resistive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_332" name="cb_332" className='add-only' value="1" /> Belligerent
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_333" name="cb_333" className='add-only' value="1" /> Reserved
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_334" name="cb_334" className='add-only' value="1" /> Negativistic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_335" name="cb_335" className='add-only' value="1" /> Sarcastic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_336" name="cb_336" className='add-only' value="1" /> Suspicious
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_337" name="cb_337" className='add-only' value="1" /> Guarded
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb_338" name="cb_338" className='add-only' value="1" /> Other
                            <input type='text' id="txt_339" name="txt_339" className='add-only' />
                        </td>
                    </tr>
                </table>

                
                <p><span className='eleHeader'>Motor Activity:</span></p>
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_125" name="cb_125" className='add-only' value="1" /> Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_126" name="cb_126" className='add-only' value="1" /> Tic(s)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_127" name="cb_127" className='add-only' value="1" /> Mannerism
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_132" name="cb_132" className='add-only' value="1" /> Paralysis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_133" name="cb_133" className='add-only' value="1" /> Restlessness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_134" name="cb_134" className='add-only' value="1" /> Slurred
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_135" name="cb_135" className='add-only' value="1" /> Speech
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_136" name="cb_136" className='add-only' value="1" /> Pressured Speech
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_137" name="cb_137" className='add-only' value="1" /> Rapid Speech
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_138" name="cb_138" className='add-only' value="1" /> Speech
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_139" name="cb_139" className='add-only' value="1" /> Pressured Speech
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_140" name="cb_140" className='add-only' value="1" /> Rapid Speech
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_141" name="cb_141" className='add-only' value="1" /> Motor Retardation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_142" name="cb_142" className='add-only' value="1" /> Sluggish
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Tremulous</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_128" name="cb_128" className='add-only' value="1" /> Hands
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_129" name="cb_129" className='add-only' value="1" /> Arms
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_130" name="cb_130" className='add-only' value="1" /> Trunks
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cb_131" name="cb_131" className='add-only' value="1" /> Whole Body
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" id="cb_143" name="cb_143" className='add-only' value="1" /> Other:<br />
                    <textarea id="txt_144" name="txt_144" className='add-only'></textarea>
                </p>
                
                <p><span className='eleHeader'>Affect:</span></p>
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_145" name="cb_145" className='add-only' value="1" /> Appropriate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_146" name="cb_146" className='add-only' value="1" /> Euphoric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_147" name="cb_147" className='add-only' value="1" /> Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_148" name="cb_148" className='add-only' value="1" /> Fearful
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_149" name="cb_149" className='add-only' value="1" /> Confused
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_150" name="cb_150" className='add-only' value="1" /> Anxious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_151" name="cb_151" className='add-only' value="1" /> Apathetic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_152" name="cb_152" className='add-only' value="1" /> Flattened
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_153" name="cb_153" className='add-only' value="1" /> Blunted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_154" name="cb_154" className='add-only' value="1" /> Restricted
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_155" name="cb_155" className='add-only' value="1" /> Labile
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_156" name="cb_156" className='add-only' value="1" /> Inappropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_157" name="cb_157" className='add-only' value="1" /> Angry
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-375'>
                            <input type="checkbox" id="cb_158" name="cb_158" className='add-only' value="1" />  Other:
                            <input type='text' id="txt_159" name="txt_159" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Reported Mood:</span>
                    <textarea id="txt_160" name="txt_160" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_161" name="cb_161" className='add-only' value="1" /> Congruent
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb_162" name="cb_162" className='add-only' value="1" /> Incongruent
                        </td>
                    </tr>
                </table>
                
                <p><span className='eleHeader'>Thought Form:</span></p>
                
                <table>
                    <tr>
                        <td className='w-300'>
                            <input type="checkbox" id="cb_340" name="cb_340" className='add-only' value="1" /> Normal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_341" name="cb_341" className='add-only' value="1" /> Tangential Thinking
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cb_342" name="cb_342" className='add-only' value="1" /> Loose Associations
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-300'>
                            <input type="checkbox" id="cb_343" name="cb_343" className='add-only' value="1" /> Slowness in Thought Associations
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_344" name="cb_344" className='add-only' value="1" /> Incoherent

                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cb_345" name="cb_345" className='add-only' value="1" /> Confused
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_346" name="cb_346" className='add-only' value="1" /> Flight of Ideas
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-375'>
                            <input type="checkbox" id="cb_347" name="cb_347" className='add-only' value="1" /> Other
                            <input type='text' id="txt_348" name="txt_348" className='add-only' />
                        </td>
                    </tr>
                </table>
                
                <p><span className='eleHeader'>Thought Content:</span></p>
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_349" name="cb_349" className='add-only' value="1" /> Normal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_350" name="cb_350" className='add-only' value="1" /> Suicidal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_351" name="cb_351" className='add-only' value="1" /> Homicidal
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_352" name="cb_352" className='add-only' value="1" /> Ideas of Reference
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_353" name="cb_353" className='add-only' value="1" /> Paranoid Trends

                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_354" name="cb_354" className='add-only' value="1" /> Delusions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_355" name="cb_355" className='add-only' value="1" /> Hypochondriac
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Hallucination</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rb_356_1" name="rb_356" className='add-only' value="1" /> Auditory
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rb_356_2" name="rb_356" className='add-only' value="2" />  Visual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb_357" name="cb_357" className='add-only' value="1" /> Other:
                            <input type='text' id="txt_358" name="txt_358" className='add-only' />
                        </td>
                    </tr>
                </table>
                
                <p><span className='eleHeader'>Cognitive Problems:</span></p>
                
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_359" name="cb_359" className='add-only' value="1" /> None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_360" name="cb_360" className='add-only' value="1" /> Recent Memory
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_361" name="cb_361" className='add-only' value="1" /> Remote Memory
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_362" name="cb_362" className='add-only' value="1" /> Comprehension
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_363" name="cb_363" className='add-only' value="1" /> Attention Span

                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-250'>
                            <input type="checkbox" id="cb_364" name="cb_364" className='add-only' value="1" /> Other
                            <input type='text' id="txt_365" name="txt_365" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Lethality Assessment</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Suicidal</span>
                            <input type="radio" id="rb_366_1" name="rb_366" className='add-only' value="1" /> None &nbsp;
                            <input type="radio" id="rb_366_2" name="rb_366" className='add-only' value="2" /> Low &nbsp;
                            <input type="radio" id="rb_366_3" name="rb_366" className='add-only' value="3" /> High
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Suicidal</span>
                            <input type="radio" id="rb_367_1" name="rb_367" className='add-only' value="1" /> None &nbsp;
                            <input type="radio" id="rb_367_2" name="rb_367" className='add-only' value="2" /> Low &nbsp;
                            <input type="radio" id="rb_367_3" name="rb_367" className='add-only' value="3" /> High
                        </td>
                    </tr>
                </table>

                <h3>Orientation</h3>
                <table> 
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person</span>
                            <input type="radio" id="rb_368_1" name="rb_368" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rb_368_2" name="rb_368" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Place</span>
                            <input type="radio" id="rb_369_1" name="rb_369" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rb_369_2" name="rb_369" className='add-only' value="2" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Situtation</span>
                            <input type="radio" id="rb_370_1" name="rb_370" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rb_370_2" name="rb_370" className='add-only' value="2" /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Intellectual Functioning</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_371_1" name="rb_371" className='add-only' value="1" /> Below Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_371_2" name="rb_371" className='add-only' value="2" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_371_3" name="rb_371" className='add-only' value="3" /> Above Average
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Activities of Daily living</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_372_1" name="rb_372" className='add-only' value="1" /> Below Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_372_2" name="rb_372" className='add-only' value="2" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_372_3" name="rb_372" className='add-only' value="3" /> Above Average
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Fund of Knowledge</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_373_1" name="rb_373" className='add-only' value="1" /> Below Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_373_2" name="rb_373" className='add-only' value="2" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_373_3" name="rb_373" className='add-only' value="3" /> Above Average
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgement</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_374_1" name="rb_374" className='add-only' value="1" /> Below Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_374_2" name="rb_374" className='add-only' value="2" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_374_3" name="rb_374" className='add-only' value="3" /> Above Average
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight Into Problem</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rb_375_1" name="rb_375" className='add-only' value="1" /> Below Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_375_2" name="rb_375" className='add-only' value="2" /> Average
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rb_375_3" name="rb_375" className='add-only' value="3" /> Above Average
                        </td>
                    </tr>
                </table>

                {/* <%--

<h4>Diagnosis:</h4>
<p>
    <span className='eleHeader'>Axis I:</span>
    <textarea id="txt_376" name="txt_376" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Axis II:</span>
    <textarea id="txt_378" name="txt_378" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Axis III:</span>
    <textarea id="txt_379" name="txt_379" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Axis IV:</span>
    <textarea id="txt_380" name="txt_380" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Axis V:</span>
    <textarea id="txt_381" name="txt_381" className='add-only'></textarea>
</p>

--%> */}
                <h4>For Substance Abuse, Indicate ASAM-Patient Placement Criteria Appplied:</h4>
                <p>
                    <span className='eleHeader'>Level of Service</span>
                    <input type="radio" id="rb_382_1" name="rb_382" className='add-only' value="1" /> 0.5 &nbsp;
                    <input type="radio" id="rb_382_2" name="rb_382" className='add-only' value="2" /> I &nbsp;
                    <input type="radio" id="rb_382_3" name="rb_382" className='add-only' value="3" /> II &nbsp;
                    <input type="radio" id="rb_382_4" name="rb_382" className='add-only' value="4" /> III &nbsp;
                    <input type="radio" id="rb_382_5" name="rb_382" className='add-only' value="5" /> IV
                </p>
                <p>
                    <span className='eleHeader'>If Identified level of service is not currently available, descrribe service plan
                        that will be implemented:</span>
                    <textarea id="txt_383" name="txt_383" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client/Family Needs:
                    </span>
                    <textarea id="txt_384" name="txt_384" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What Services Are Needed?
                    </span>
                    <textarea id="txt_385" name="txt_385" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client Family Participated in completion of this Assessment?</span>
                    <span className='small'>If no, please explain why:</span>
                    <input type="radio" id="rb_386_1" name="rb_386" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rb_386_2" name="rb_386" className='add-only' value="2" /> No
                    <br />
                    <textarea id="txt_387" name="txt_387" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Other Important Information:</span>
                    <textarea id="txt_388" name="txt_388" className='add-only'></textarea>
                </p>





            </div>
        </form>

    )
}   